<template>
    <div class="conf-wrp">
        <div class="content-wrp">
            <div class="content">
                <el-form class="form" :model="value" :rules="rules" ref="form" label-width="20%">
                    <section>
                        <div class="title">
                            <span>基础设置</span>
                        </div>
                        <div class="conf">
                            <el-form-item label="标题设置:" prop="titleSet">
                                <el-checkbox v-model="value.titleSet">商品标题超过平台限制自动截断（最多60个字符）</el-checkbox>
                            </el-form-item>
                            <el-form-item label="拼多多商品货号设置:" prop="isCommodityNumber">
                                <el-checkbox :true-label="1" :false-label="0" v-model="value.isCommodityNumber">基础资料款式编码自动填充拼多多商品货号</el-checkbox>
                                <span class="ft-12 ml-10 text-red">（注意：开启配置，新增拼多多资料时，基础资料款式编码自动填充拼多多商品货号，若拼多多资料已完善，则不会自动填充。）</span>
                            </el-form-item>
                            <el-form-item label="下载平台商品，商品描述设置:" prop="describeSet">
                                <el-checkbox v-model="value.describeSet">商品描述默认置空</el-checkbox>
                            </el-form-item>
                            <el-form-item label="商品详情图:" prop="imgNumSet">
                                <el-checkbox v-model="value.imgNumSet">商品详情图超过平台限制张自动截断（最多50张）</el-checkbox>
                            </el-form-item>
                            <el-form-item label="品牌来源设置:" prop="isCommodityBrand">
                                <el-checkbox v-model="value.isCommodityBrand">应用来源链接【品牌】值</el-checkbox>
                                <span class="ft-12 ml-10 text-red">(注意：该配置可应用于药品，3C，图书等类目，用于便捷填充多店铺品牌值，若发布非标品且多店铺品牌不一致，谨慎使用！)</span>
                            </el-form-item>
                            <el-form-item label="规格图调整时，规格预览图是否变更:">
                                <el-radio v-model="value.isUpdateSkuImg" :label="1">变更</el-radio>
                                <el-radio v-model="value.isUpdateSkuImg" :label="0">不变更</el-radio>
                                <span class="ft-12 ml-10 text-red">(注意：不变更时，拼多多规格图调整不影响预览图，除非预览图为空时，默认取规格图片)</span>
                            </el-form-item>
                            <el-form-item label="发货时效配置：">
                                <el-checkbox v-model="value.isSkuPreSaleDay" :true-label="1" :false-label="0">定时预售是否自动更新sku发货时效</el-checkbox>
                                <span class="ft-12 ml-10 text-red">(注意：开启配置会根据配置的定时预售时间，编辑平台资料或铺货时自动更新sku预售时间，对应sku发货时效变更为当前日期+预售时间对应的日期23:59:59)</span>
                            </el-form-item>
                            <el-form-item>
                                <el-checkbox v-model="other.isOpenSkuPreSaleDays" :true-label="1" :false-label="0">下载商品后，定时预售，默认填充sku发货时效天数</el-checkbox>
                                <span class="ft-12 ml-10 text-red">(注意：填充发货时效仅针对设置预售时间的sku生效，若sku均设定发货时效，则默认覆盖款维度发货时效)</span>
                            </el-form-item>
                            <el-form-item v-show="other.isOpenSkuPreSaleDays" prop="openSkuPreSaleDays">
                                <el-input v-model="value.openSkuPreSaleDays" regexp="^([1-2]?[0-9]?)$" clearable style="width: 100px" />
                                <span class="ml-10 ft-12">天结束预售</span>
                            </el-form-item>
                            <el-form-item label="轮播视频自动上传配置:" prop="isCommodityBrand">
                                <el-button type="link" @click="chooseShops">选择店铺</el-button>
                                <span>(已选店铺：<span style="color: #2695FA">{{ value.autoUploadVideoGalleryShops.length }}</span>)</span>
                                <span class="ft-12 ml-10 text-red">(注意：拼多多店铺下载平台商品或生成拼多多资料时，若商品存在轮播视频，则自动上传至所选店铺素材空间！)</span>
                            </el-form-item>
                            <el-form-item label="满件折扣：">
                                <span>满2件</span>
                                <el-input v-model="value.twoPiecesDiscount" placeholder="请输入" regexp="^(([5-9](\.\d{0,1})?)|0?)$" style="width: 120px">
                                    <template slot="append">折</template>
                                </el-input>
                                <span class="ft-12 ml-10 text-red">(注意：支持填写5.0-9.9，填写0时该配置不生效。该配置为商品满2件折扣与店铺满2件折扣不叠加)</span>
                            </el-form-item>
                            <el-form-item label="服务与承诺：">
                                <el-checkbox v-model="value.isFolt">假一赔十</el-checkbox>
                            </el-form-item>
                            <el-form-item label="自动删除超限SKU配置：">
                                <el-checkbox v-model="value.isAutoTrimSku" :true-label="1" :false-label="0">铺货时自动截取删除超过平台发布商品要求上限的sku</el-checkbox>
                            </el-form-item>
                            <el-form-item label="店铺品牌设置：">
                                <BrandSettingConfig
                                    v-if="shopList.length"
                                    ref="branchSettingConfig"
                                    v-model="brandConfList"
                                    :shopList="shopList"
                                />
                                <span class="no-shops" v-else>暂无平台店铺</span>
                            </el-form-item>
                            <el-form-item label="类目外品牌设置：">
                                <BrandSettingOtherConfig
                                    v-if="shopList.length"
                                    ref="branchSettingConfig"
                                    v-model="dataSourceCategory"
                                    :shopList="shopList"
                                />
                                <span class="no-shops" v-else>暂无平台店铺</span>
                            </el-form-item>
                        </div>
                    </section>
                    <section>
                        <div class="title">
                            <span>库存设置</span>
                        </div>
                        <div class="conf">
                            <el-form-item label="铺货时，进行库存默认设置:" >
                                <el-switch v-model="checkInstock"></el-switch>
                            </el-form-item>
                            <el-form-item v-if="checkInstock" label="库存默认值" prop="instock">
                                <div class="instock">
                                    <span class="prev">铺货到拼多多的SKU库存默认值&nbsp;=&nbsp;</span>
                                    <el-input v-model="value.instock" style="width: 120px" placeholder="请输入库存数"></el-input>
                                    <span class="tips">&nbsp;(此值应用于商品铺货时，对商品各SKU的库存初始化值，最大值为99999)</span>
                                </div>
                            </el-form-item>
                        </div>
                    </section>
                    <section>
                        <div class="title">
                            <span>图片设置</span>
                        </div>
                        <div class="conf">
                            <div style="padding-left:15%;">图片修正规则：按照平台比例和尺寸大小要求，修正成最优且符合要求的图片。若图片大小不符合平台要求，将自动压缩后重新上传，不支持压缩20M以上的图片。</div>
                            <el-form-item prop="autoCropImageConfigList">
                                <el-checkbox-group v-model="value.autoCropImageConfigList">
                                    <el-checkbox label="carouselGalleryImg">商品轮播图</el-checkbox>
                                    <el-checkbox label="desc">商品详情图</el-checkbox>
                                    <el-checkbox label="skuImg">规格图</el-checkbox>
                                    <el-checkbox label="whiteImg">白底图</el-checkbox>
                                    <el-checkbox label="mainLengthImg">长图</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </div>
                    </section>
                     <section>
                        <div class="title">
                            <span>运费模板设置</span>
                        </div>
                        <div class="conf">
                            <el-form-item label="运费设置:" prop="shipSet" label-width="120px">
                                <div class="ship-wrp" v-if="shopList.length > 0">
                                    <div class="item" v-for="(item, idx) in shopList" :key="idx">
                                        <div class="shopname" :data-id="item.id">
                                            <img class="shop-img" :src="item.icon"/>
                                            <el-tooltip v-if="item.channelIcon" :content="item.channelName" style="margin: 0px -6px 0px 6px;">
                                                <el-image :src="item.channelIcon" style="width: 18px; height: 18px;overflow: unset;top: 4px;"></el-image>
                                            </el-tooltip>
                                            <span>{{ item.shortTitle || item.title }}</span>
                                        </div>
                                        <el-select 
                                            :loading="selectLoading" 
                                            v-model="shipsValue[item.id]" 
                                            placeholder="请选择运费模板" 
                                            clearable
                                            @visible-change="changeSelect(item.id, item.userId)"
                                            width="150px">
                                            <el-option
                                                v-for="ship in shipsTemplate[item.id]"
                                                :key="ship.id"
                                                :label="ship.name"
                                                style="width: 150px;"
                                                :title="ship.name"
                                                :value="ship.id">
                                            </el-option>
                                        </el-select>
                                        <div><el-link class="no-border" @click="refreshTemplate(item.id, item.userId)">刷新模板</el-link></div>
                                    </div>
                                </div>
                                <span v-else class="no-shops">暂无平台店铺</span>
                            </el-form-item>
                        </div>
                    </section>
                    <section>
                        <div class="title">
                            <span>上架设置</span>
                        </div>
                        <div class="conf">
                            <el-form-item label="上架设置:" prop="shelfType">
                                <el-radio-group v-model="value.shelfType">
                                    <el-radio :label="1">立即上架</el-radio>
                                    <el-radio :label="2">放入草稿箱</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                    </section>
                    <PriceConf ref="PriceConfRef" platform="pdd" :priceList="value.price" :shopPriceConf="value.shopPriceConf"></PriceConf>
                    <div class="btns" style="margin: 0px;">
                        <el-button type="primary" @click="save">保存模板</el-button>
                        <el-button @click="back">返回</el-button>
                    </div>
                </el-form>
            </div>
        </div>
        <CascaderDialog platform="pdd" ref="CascaderDialog" />
        <el-dialog-select-shop
            :visible.sync="shopDialogVisible"
            :shopData="shopDialogList"
            :selected="autoUploadVideoGalleryShopsUserIds"
            placeholder="店铺名称"
            @confirm="confirmSelectShop"
        ></el-dialog-select-shop>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import CascaderDialog from '../center/components/PlatformCategoryInput/CascaderDialog.vue'
import '@/assets/css/prod.scss';
import {getDistributionConfig, updateDistributionConfig, getPddTemplateList} from '@servers/prod/conf/index.js'
import PriceConf from './components/PriceConf.vue';
import BrandSettingOtherConfig from './components/BrandSettingOtherConfig/';
import BrandSettingConfig from './components/BrandSettingConfig/';
import { cloneDeep } from 'lodash';


const PLATFORMID = 'PinShop';

const validateNumber = (min, max) => {
    return (_, value, callback) => {
        if (value && (value < min || value > max)) {
            callback(new Error(`时间不能小于${min}天且大于${max}天`))
        } else {
            callback();
        }
    };
};

export default {
    props: {
        back: Function
    },
    provide(){
        return {
            platform:'pdd',
        }
    },
    components: {
        CascaderDialog,
        PriceConf,
        BrandSettingConfig,
        BrandSettingOtherConfig
    },
    computed:{
        ...mapGetters(['shops_all']),
        dataSourceCategory: {
            get(){
                if (!this.categoryBrandRelationsList?.length) {
                    return [];
                }
                return this.categoryBrandRelationsList.flatMap(item => 
                    item.relations.map(childRelation => ({
                        ...childRelation,
                        previewCategoryId: childRelation.categoryId,
                        parent: { shopId: item.shopId }
                    }))
                );
            },
            set(next){
                const grouped = {};
                (next || []).forEach(row => {
                    const shopId = row?.parent?.shopId;
                    if(!shopId) return;
                    if(!grouped[shopId]) grouped[shopId] = [];
                    const copy = { ...row };
                    delete copy.parent;
                    delete copy.previewCategoryId;
                    grouped[shopId].push(copy);
                });
                this.categoryBrandRelationsList = Object.keys(grouped).map(shopId => ({
                    shopId: isNaN(Number(shopId)) ? shopId : Number(shopId),
                    shopType: PLATFORMID,
                    relations: grouped[shopId]
                }));
            }
        }
    },
    data() {
        const validateInstock = (rule, value, callback) => {
            const reg = /^[0-9]*$/;
            if (value === '') {
                callback(new Error('请输入库存数'));
            } else if (!reg.test(value)) {
                callback(new Error('库存数必须是数字, 且为整数'))
            } else if (value <= 0 || value >= 99999) {
                callback(new Error('库存数必须为0-99999之间的整数'))
            } else {
                callback();
            }
        }
        return {
            categoryBrandRelationsList:[],
            brandConfList: [],
            checkInstock: false,
            shopList: [],
            shopDialogList: [],
            shopDialogVisible: false,
            autoUploadVideoGalleryShopsUserIds: '',
            value: {
                titleSet: false,
                isCommodityNumber: 0,
                imgNumSet: false,
                describeSet: false,
                shelfType: 2,
                instock: null,
                isCommodityBrand: false,
                isSkuPreSaleDay: 0,
                openSkuPreSaleDays: 3,
                autoUploadVideoGalleryShops: [],
                isUpdateSkuImg: 0,
                autoCropImageConfigList:[],
                twoPiecesDiscount: 0,
                isFolt: false,
                isAutoTrimSku: 0
            },
            selectBrandLoading: false,
            selectLoading: false,
            rules: {
                instock: [
                    {required: true, message: '请输入库存数'},
                    {validator: validateInstock}
                ],
                shelfType: [
                    {required: true, message: ''},
                ],
                openSkuPreSaleDays: [
                    { validator: validateNumber(3, 29) }
                ],
            },
            shipsValue: {// 运费模板
            },
            shipsTemplate: { // 运费模板列表

            },
            other: { isOpenSkuPreSaleDays: 0 },
        }
    },
    watch:{
        shops_all:{
            handler(val) {
                if (val.length) {
                    this.getConf();
                }
            }
        }
    },
    mounted() {
        this.getConf();
    },
    methods: {
        async getConf() {
            const res = await getDistributionConfig({shopType: PLATFORMID});
            const shopList = this.$store.getters.get_AllShops_BySource('pdd');
            this.shopList = shopList;
            this.shopDialogList = shopList.filter(shop => [2, 3].includes(shop.state) && shop.isDeadline !== 1)
            if (res) {
                this.checkInstock = res.isCommodityStock === 1;
                this.value.instock = res.stockNumber;
                this.value.titleSet = res.isCommodityTitle === 1;
                this.value.isCommodityNumber = res.isCommodityNumber || 0;
                this.value.describeSet = res.isCommodityDescription === 1;
                this.value.imgNumSet = res.isCommodityImage === 1;
                this.value.isCommodityBrand = res.isCommodityBrand === 1;
                this.value.shelfType = res.shelfState || this.value.shelfType;
                this.value.price = res.price ? JSON.parse(res.price) : [];
                this.value.shopPriceConf = res.shopPriceConf ? JSON.parse(res.shopPriceConf) : [];
                this.value.isSkuPreSaleDay = res.isSkuPreSaleDay || 0;
                this.other.isOpenSkuPreSaleDays = res.openSkuPreSaleDays ? 1 : 0;
                this.value.openSkuPreSaleDays = res.openSkuPreSaleDays || 3;
                this.value.autoUploadVideoGalleryShops = res.autoUploadVideoGalleryShops ? JSON.parse(res.autoUploadVideoGalleryShops) : [];
                this.autoUploadVideoGalleryShopsUserIds = this.value.autoUploadVideoGalleryShops.map(id => this.shopDialogList.find(shop => shop.id == id)?.userId).filter(Boolean).join(',')
                this.value.isUpdateSkuImg = 'isUpdateSkuImg' in res ? res.isUpdateSkuImg : 1;
                this.value.autoCropImageConfigList = res.autoCropImageConfigList ? res.autoCropImageConfigList : [];
                this.value.twoPiecesDiscount = (res.twoPiecesDiscount || 0) / 10;
                this.value.isFolt = !!res.isFolt;
                this.value.isAutoTrimSku = res.isAutoTrimSku;
            }
            const { templateList, categoryBrandRelations = [],brandConfList} = res || {};

            this.intiTemplate(shopList, templateList);
            this.categoryBrandRelationsList = categoryBrandRelations
            this.handleUniqData(brandConfList || []);
        },
        handleUniqData(value){
            const list = cloneDeep(value)
            const data = list.map((item,index)=>{
                // item.id = uniqueId(index+'_')
                item.id = index+'_'+item.shopIds.join('')
                return item
            })
            // console.log(data, list, 'newValue--');
            this.brandConfList = data
        },
        async getTemplateList(userId) {
            const list = await getPddTemplateList({
                offset: 0,
                limit: 100,
                searchUsed: false,
                userId: userId
            });
            if (list) {
                return list.map(ship => {
                    return {
                        name: ship.templateName,
                        id: ship.templateId.toString()
                    }
                });
            }
            return [];
        },
        async refreshTemplate(shopId, userId) {
            this.selectLoading = true;
            const list = await this.getTemplateList(userId);
            this.shipsTemplate[shopId] = list;
            const idx = list.findIndex(item => item.id === this.shipsValue[shopId]);
            if (idx === -1) {
                this.shipsValue[shopId] = '';
            }
            this.selectLoading = false;
            this.$message.success('刷新模板成功')
        },
        intiTemplate(shopList, templateList=[]) {
            const ships = {};
            const shipsTemp = {};
            for(let shop of shopList) {
                const shopId = shop.id;
                const temlpateVals = templateList.find(item=> item.shopId == shopId);
                shipsTemp[shopId] = [];
                ships[shopId] = '';
                if(temlpateVals) {
                    shipsTemp[shopId] = [{name: temlpateVals.templateName, id: temlpateVals.templateId}]
                    ships[shopId] = temlpateVals.templateId;
                }
            }
            this.shipsTemplate = shipsTemp;
            this.shipsValue = ships;
        },
        async changeSelect(shopId, userId) {
            if (!this.shipsTemplate[shopId] || !this.shipsTemplate[shopId].length ||
                (this.shipsTemplate[shopId].length === 1 && this.shipsTemplate[shopId][0].id === this.shipsValue[shopId])) {
                this.selectLoading = true;
                const list = await this.getTemplateList(userId)
                const idx = list.findIndex(item => item.id === this.shipsValue[shopId]);
                if (idx === -1) {
                    this.shipsValue[shopId] = '';
                }
                this.shipsTemplate[shopId] = list;
                this.selectLoading = false;
            }
        },
        findTemplateName(shopid, tempId) {
            if (!this.shipsTemplate[shopid]) return '';
            for(let item of this.shipsTemplate[shopid]) {
                if (item.id === tempId) {
                    return item.name;
                }
            }
        },
        save() {
            this.$refs.form.validate(async valid => {
                if (valid) {
                    const {
                        titleSet,
                        describeSet,
                        isCommodityNumber,
                        imgNumSet,
                        instock,
                        shelfType,
                        isCommodityBrand,
                        isSkuPreSaleDay,
                        openSkuPreSaleDays,
                        autoUploadVideoGalleryShops,
                        isUpdateSkuImg,
                        autoCropImageConfigList,
                        twoPiecesDiscount,
                        isFolt,
                        isAutoTrimSku
                    } = this.value;
                    const { isOpenSkuPreSaleDays } = this.other;
                    const templateList = [];
                    this.shopList.forEach(item => {
                        const id = item.id;
                        const name = this.findTemplateName(id, this.shipsValue[id]);
                        const channel = this.shopList.find(shop => shop.id == id)?.channel
                        templateList.push({
                            shopId: id, // id 不是 userId
                            templateId: this.shipsValue[id] || null,
                            templateName: name || null,
                            channel
                        });
                    })
                    // const categoryBrandRelations = this.getBrandConfParamsNew()
                    let [commConf,shopConf] = this.$refs.PriceConfRef.getData();
                    const res = await updateDistributionConfig({
                        shopType: PLATFORMID,
                        isCommodityTitle: titleSet ? 1 : 0,
                        isCommodityNumber: isCommodityNumber,
                        isCommodityImage: imgNumSet ? 1 : 0,
                        isCommodityDescription: describeSet ? 1 : 0,
                        isCommodityStock: this.checkInstock ? 1 : 0,
                        stockNumber: this.checkInstock ? `${instock === null ? '' : instock}` : '',
                        shelfState: shelfType,
                        templateList: templateList,
                        categoryBrandRelations: this.categoryBrandRelationsList,
                        brandConfList: this.brandConfList,
                        isCommodityBrand: isCommodityBrand ? 1 : 0,
                        isSkuPreSaleDay,
                        openSkuPreSaleDays: (isOpenSkuPreSaleDays == 1 && openSkuPreSaleDays) ? openSkuPreSaleDays * 1 : null,
                        isUpdateSkuImg,
                        autoCropImageConfigList,
                        price: JSON.stringify(commConf),
                        shopPriceConf:JSON.stringify(shopConf),
                        autoUploadVideoGalleryShops: JSON.stringify(autoUploadVideoGalleryShops),
                        twoPiecesDiscount: Number(twoPiecesDiscount) * 10,
                        isFolt: +isFolt,
                        isAutoTrimSku
                    });
                    if (res) {
                        this.$message.success('保存成功');
                        this.getConf();
                    }
                }
            })
        },
        chooseShops() {
            this.shopDialogVisible = true
        },
        confirmSelectShop(list) {
            let userIdList = []
            this.value.autoUploadVideoGalleryShops = list.map(shop => {
                userIdList.push(shop.userId)
                return shop.id
            }) 
            this.autoUploadVideoGalleryShopsUserIds = userIdList.join(',')
        },

        // getBrandConfParamsNew() {
        //     const _categoryBrandRelationsList = Object.assign([], this.categoryBrandRelationsList)
        //     console.log(JSON.parse(JSON.stringify(_categoryBrandRelationsList)), '----_categoryBrandRelationsList---');

        //     const data = _categoryBrandRelationsList.map((item)=>{
        //         const relations = item.relations.map(rel => {
        //             delete rel.parent
        //             return rel
        //         })
        //         return {
        //             shopId: item.shopId,
        //             shopType: PLATFORMID,
        //             relations,
        //         }
        //     })
        //     console.log(data.filter(item=>item.relations.length!=0), '----data.filter(item=>item.relations.length!=0)---');

        //     return data.filter(item=>item.relations.length!=0)
        // },
    }
}
</script>

<style lang="scss" scoped>
// .btns {
//     position: fixed;
//     bottom: 0px;
//     left: 0px;
//     width: 100%;
//     padding: 10px 45%;
//     background: #F8F8F8;
//     margin: 0px;
// }

</style>